import React, { useState, useEffect } from "react";
import { ResponsivePie } from "@nivo/pie";
import Bridge from "../../constants/Bridge";
import $ from "jquery";

const AsianDemographics = () => {
  const [asianReports, setAsianReports] = useState([]);
  const [totalOfAsianReport, setTotalOfAsianReport] = useState(0);

  useEffect(() => {
    getReportData();
  }, []);

  const getReportData = () => {
    Bridge.speech_study
      .all_demographics_chart_data()
      .then((result) => {
        if (result.status == "1") {
          setData(result.data);
        }
      })
      .catch((error) => {});
  };

  const setData = (data) => {
    let asianReports = [];
    let hispanicReports = [];
    let portalReports = [];
    let sum1 = 0;
    let sum2 = 0;
    let sum3 = 0;

    for (const item of data) {
      if (
        item.field == "DEMOG521" ||
        item.field == "DEMOG522" ||
        item.field == "DEMOG523" ||
        item.field == "DEMOG524" ||
        item.field == "DEMOG525" ||
        item.field == "DEMOG526" ||
        item.field == "DEMOG527"
      ) {
        asianReports = [...asianReports, item];
        sum1 += item.count;
      }

      if (
        item.field == "DEMOG41" ||
        item.field == "DEMOG42" ||
        item.field == "DEMOG43" ||
        item.field == "DEMOG44"
      ) {
        hispanicReports = [...hispanicReports, item];
        sum2 += item.count;
      }

      if (
        item.field == "DEMOG51" ||
        item.field == "DEMOG52" ||
        item.field == "DEMOG53" ||
        item.field == "DEMOG54" ||
        item.field == "DEMOG55" ||
        item.field == "DEMOG56" ||
        item.field == "DEMOG57" ||
        item.field == "DEMOG4"
      ) {
        if (item.field == "DEMOG4") {
          item.field_description = "Of Hispanic, Latino/a or Spanish origin";
        }
        portalReports = [...portalReports, item];
        sum3 += item.count;
      }
    }

    console.log("asianReports", asianReports);
    console.log("hispanicReports", hispanicReports);
    console.log("portalReports", portalReports);

    setTotalOfAsianReport(sum1);
    const sum1OnePercent = Number(sum1 / 100);
    const sum2OnePercent = Number(sum2 / 100);
    const sum3OnePercent = Number(sum3 / 100);

    for (let d1 of asianReports) {
      d1.percentage = (Number(d1.count) / Number(sum1OnePercent)).toFixed(2);
    }
    for (let d2 of hispanicReports) {
      d2.percentage = (Number(d2.count) / Number(sum2OnePercent)).toFixed(2);
    }
    for (let d3 of portalReports) {
      d3.percentage = (Number(d3.count) / Number(sum3OnePercent)).toFixed(2);
    }
    setAsianReports(asianReports);
  };

  const asianPieData =
    asianReports &&
    asianReports.map((item, index) => {
      return {
        id: item.field_description + " (" + item.percentage + "%) ",
        label: item.field_description + " (" + item.percentage + "%) ",
        value: item.count,
        color: "#" + Math.floor(Math.random() * 0xffffff).toString(16),
      };
    });

  return (
    <div>
      <div className="row">
        <div className="col-lg-12 main-section add-user" style={{ paddingTop: 0 }}>
          <div className="wrapper clearfix position-relative" style={{ paddingTop: 0, background: "#fff", transform: "scale(1)" }}>
            <div className="multisteps-form import-participant-block">
              <div className="bg-white" id="main-section">
                <div className="row bg-white" id="section-1">
                  <div className="col-12 col-lg-12" style={{ marginBottom: 40 }}>
                    <div className="wizard-content-form ethnicity-report-1 bg-white diagnosis-report">
                      <div className="wizard-form-field ml-0" style={{ margin: "0px 0 14px 14px" }}>
                        <br />
                        <div style={{ width: "95%" }} className="graph-outer">
                          <div className="main-download-button">
                            <h1 className="pt-4" style={{ fontSize: 27, fontWeight: "600", marginTop: -40, marginBottom: 50 }}>
                              Asian Demographic -{" "}
                              <span className="">
                                (Total Participants - {totalOfAsianReport})
                              </span>
                            </h1>
                          </div>
                          <ResponsivePie
                            data={asianPieData}
                            margin={{
                              top: $(window).width() < 600 ? 0 : 40,
                              right: $(window).width() < 600 ? 100 : 0,
                              bottom: 80,
                              left: $(window).width() < 600 ? 60 : -130,
                            }}
                            startAngle={-18}
                            innerRadius={0.5}
                            padAngle={0.7}
                            activeOuterRadiusOffset={8}
                            colors={{ scheme: "red_yellow_green" }}
                            borderWidth={1}
                            borderColor={{
                              from: "color",
                              modifiers: [["darker", 0.2]],
                            }}
                            arcLinkLabelsSkipAngle={10}
                            arcLinkLabelsTextColor="#000"
                            arcLinkLabelsThickness={2}
                            arcLinkLabelsColor={{ from: "color" }}
                            arcLabelsSkipAngle={10}
                            arcLabelsTextColor={{
                              from: "color",
                              modifiers: [["darker", 2]],
                            }}
                            defs={[
                              {
                                id: "dots",
                                type: "patternDots",
                                background: "inherit",
                                color: "#000",
                                size: 4,
                                padding: 1,
                                stagger: true,
                              },
                              {
                                id: "lines",
                                type: "patternLines",
                                background: "inherit",
                                color: "#000",
                                rotation: -45,
                                lineWidth: 6,
                                spacing: 10,
                              },
                            ]}
                            fill={[
                              {
                                match: {
                                  id: "ruby",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "c",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "go",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "python",
                                },
                                id: "dots",
                              },
                              {
                                match: {
                                  id: "scala",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "lisp",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "elixir",
                                },
                                id: "lines",
                              },
                              {
                                match: {
                                  id: "javascript",
                                },
                                id: "lines",
                              },
                            ]}
                            legends={[
                              {
                                anchor: "right",
                                direction: "column",
                                justify: false,
                                translateX: $(window).width() < 600 ? 40 : 0,
                                translateY: $(window).width() < 600 ? 210 : 20,
                                itemsSpacing: 0,
                                itemWidth: 200,
                                itemHeight: $(window).width() < 600 ? 24 : 33,
                                itemTextColor: "#000",
                                itemDirection: "left-to-right",
                                itemOpacity: 1,
                                symbolSize: $(window).width() < 600 ? 18 : 23,
                                symbolShape: "circle",
                                effects: [
                                  {
                                    on: "hover",
                                    style: {
                                      itemTextColor: "#000",
                                    },
                                  },
                                ],
                              },
                            ]}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AsianDemographics;
